import { RootState } from "@/Redux/configureStore";
import { setDataAnalyticsFavorite } from "@/Redux/Ducks/dataAnalyticsSlice";
import { setScreenFavorite } from "@/Redux/Ducks/entryFormSlice";
import { addAttendanceRequest, addLeaveRequest, AttendanceRequest, LeaveRequest, setAllSelfServiceData, setHomeUserSpecificData, setUserDataAnalytics, setUserEntryForms, setUserObjects, setUserReport, updateAttendanceData } from "@/Redux/Ducks/homeSlice";
import { toggleLoader } from "@/Redux/Ducks/loaderSlice";
import { setGlobalMessage } from "@/Redux/Ducks/messageSlice";
import { setReportFavorite } from "@/Redux/Ducks/reportExplorerSlice";
import { addUserFavorite } from "@/Redux/Ducks/userSlice";
import { requestGetHomeUserSpecificData, requestGetSelfServiceData, requestGetUserRights, requestMarkUserAttendance, requestSetObjectFavorite } from "@/Redux/Sagas/Requests/home";
import { openAlert } from "@/UI/BaseComponents/Alert";
import { current, PayloadAction } from "@reduxjs/toolkit";
import { call, put, select } from "redux-saga/effects";
import { requestGetDataAnalyticsObjectMenu } from "../Requests/dataAnalytics";
import { requestSaveAttendanceRequest, requestSaveLeaveRequest } from "../Requests/entryForm";
import { requestBLForData } from "../Requests/others";
import { requestGetReportMenu } from "../Requests/reportExplorer";

export function* handleSetUserFavorite({ payload }: PayloadAction<{ objectcontrollerno: string, objectcontrollerstxt: string, applicationobjecttype: string }>): any {
  const { objectcontrollerno, objectcontrollerstxt, applicationobjecttype } = payload;

  try {
    yield put(toggleLoader(true));

    yield call(requestSetObjectFavorite, objectcontrollerno, applicationobjecttype);
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    if (applicationobjecttype == "E") {
      yield put(setScreenFavorite({ objectcontrollerno }));
    }
    else if (applicationobjecttype == "I") {
      yield put(setDataAnalyticsFavorite({ objectcontrollerno }))
    }
    else if (applicationobjecttype == "R") {
      yield put(setReportFavorite({ objectcontrollerno }))
    }

    yield put(addUserFavorite({ applicationobjecttype, objectcontrollerno, objectcontrollerstxt }));

    yield put(toggleLoader(false));
  }
}

export function* handleGetHomeUserSpecificData(): any {

  try {
    yield put(toggleLoader(true));
    const response = yield call(requestGetHomeUserSpecificData);

    yield put(setHomeUserSpecificData({ ...response }));

  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleGetUserEntryForms(): any {
  try {
    const response = yield call(requestGetUserRights);

    yield put(setUserEntryForms({ userEntryForms: response }));
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleGetUserObjects(): any {
  try {
    const response = yield call(requestGetUserRights);

    yield put(setUserObjects({ userObjects: response }));
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleGetUserDataAnalytics(): any {
  try {
    const response = yield call(requestGetDataAnalyticsObjectMenu);

    yield put(setUserDataAnalytics({ userDataAnalytics: response }));
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleGetUserReport(): any {
  try {
    const response = yield call(requestGetReportMenu);

    yield put(setUserReport({ userReport: response }));
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleUserAttendanceMark({ payload }: PayloadAction<{
  type: "timein" | "timeout",
  latitude: number,
  longitude: number,
  address: string
}>): any {
  try {
    yield put(toggleLoader(true));

    const employeeno = yield select((state: RootState) => state.Home.selectedEmployeeNo);
    const legalentityno = yield select((state: RootState) => state.User.UserLegalEntity.find(x => x.isdefault)?.legalentityno);

    const currentDate = new Date();

    const data = {
      date: currentDate,
      employeeno,
      legalentityno,
      type: payload.type,
      latitude: payload.latitude,
      longitude: payload.longitude,
      address: payload.address
    };

    const response = yield requestMarkUserAttendance(data);

    if (response?.response == "save") {
      yield put(updateAttendanceData({
        date: currentDate,
        time: currentDate,
        type: payload.type,
        latitude: payload.latitude,
        longitude: payload.longitude,
        address: payload.address
      }));

      yield put(setGlobalMessage({ message: "Check In Successfully" }));
    }
    else if (response?.response == "timeoutupdate") {
      let attendanceDate = new Date(response.attendancedate);
      let timeOut = new Date(response.attendancetimeout);

      yield put(updateAttendanceData({
        date: attendanceDate,
        time: timeOut,
        type: payload.type,
        latitude: payload.latitude,
        longitude: payload.longitude,
        address: payload.address
      }));

      yield put(setGlobalMessage({ message: "Check Out Successfully" }));
    }
    else if (response?.response == "alreadyexists") { // this is only for check in
      let attendanceDate = new Date(response.attendancedate);
      let timeIn = new Date(response.attendancetimein);

      yield put(updateAttendanceData({
        date: attendanceDate,
        time: timeIn,
        type: payload.type,
        latitude: payload.latitude,
        longitude: payload.longitude,
        address: payload.address
      }));

      yield put(setGlobalMessage({ message: "Check In Updated Successfully" }));

      // show warning Message
    }

  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleGetSelfServiceData(): any {
  try {
    yield put(toggleLoader(true));

    const { employeeno, legalentityno } = yield select((state: RootState) => ({
      employeeno: state.Home.selectedEmployeeNo,
      legalentityno: state.User.UserLegalEntity.find((x: any) => x.isdefault)?.legalentityno
    }));
    const response = yield requestGetSelfServiceData({ date: new Date(), legalentityno: legalentityno, employeeno: employeeno });
    yield put(setAllSelfServiceData({
      employeeData: response.employeeData[0],
      attendanceData: response.attendanceData,
      portalAttendanceLog: response.portalAttendanceLog,
      leaveRequests: response.leaveRequests,
      attendanceRequests: response.attendanceRequests,
      leaveData: response.leaveData,
      weekHolidays: response.weekHolidays.map((x: any) => x.weekindex),
      holidayData: response.holidayData,
      myTeam: response.myTeam,
      geoLocationData: response.geoLocationData,
      leaveBalance: response.leaveBalance,
      myTask: response.myTask,
      myTeamAtt: response.myTeamAtt,
    }));

  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleSaveLeaveRequest({ payload }: PayloadAction<LeaveRequest>): any {
  try {
    yield put(toggleLoader(true));

    const response = yield requestSaveLeaveRequest(payload);
    yield put(addLeaveRequest(response));

    openAlert({ title: `Success`, text: `Leave Request Sent`, icon: 'info' });

  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleSaveAttendanceRequest({ payload }: PayloadAction<AttendanceRequest>): any {
  try {
    yield put(toggleLoader(true));

    const response = yield requestSaveAttendanceRequest(payload);
    yield put(addAttendanceRequest(response));

    openAlert({ title: `Success`, text: `Attendance Request Sent`, icon: 'info' });

  } catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}